import React, { useState } from 'react';
import { Tab } from './tab.component';

export enum TabsPosition {
  RIGHT = 'right',
  LEFT = 'left'
}

/**
 * interface TabsProps
 */
interface TabsProps {
  data: { tabsList: { key: string; component: JSX.Element; id?: string }[]; defaultTab?: string };
  style: {
    position: TabsPosition;
  };
  eventHandlers?: {
    tabChangeHandler?: (tabKey: string, id?: string) => void;
  };
}

/**
 * functional component Tabs
 * @param data hold key and component for each tab
 */
export const Tabs: React.FC<TabsProps> = ({ data, eventHandlers, style }) => {
  const [activeTab, setActiveTab] = useState<string>(
    data.defaultTab ||
      (data.tabsList && data.tabsList[0] && data.tabsList[0] ? data.tabsList[0].key : '')
  );
  const onClickTabItem = (tab: string) => {
    setActiveTab(tab);
    const findID = data.tabsList.find((tabItem) => tabItem.key === tab);
    if (eventHandlers?.tabChangeHandler) {
      eventHandlers.tabChangeHandler(tab, findID?.id);
    }
  };
  const containerClass = `flex flex-col  ${
    style.position === TabsPosition.RIGHT ? 'flex-col-reverse' : ''
  } gap-4 items-center w-full`;

  return (
    <div className={containerClass}>
      <ol
        role="tablist"
        className="flex gap-3 justify-start  items-center overflow-x-auto  w-full p-1 mb-2"
      >
        {data.tabsList.map((child) => {
          const { key } = child;

          return (
            <Tab
              key={key}
              config={{ activeTab }}
              data={{ key }}
              eventHandlers={{ onClickHandler: onClickTabItem }}
            />
          );
        })}
      </ol>
      <div className="flex-1 rounded-xl  transition-all ease-in-out duration-200">
        {data.tabsList.map((child) => {
          if (child.key !== activeTab) return undefined;
          return child.component;
        })}
      </div>
    </div>
  );
};
